import { theme } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const { useToken } = theme;

interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
}

const Logo: React.FC<LogoProps> = ({ className, style }) => {
  const { token } = useToken();

  return (
    <Link
      to="/"
      style={{
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        ...style
      }}
      className={className}
    >
      <img
        src="/logo.png"
        alt="FlipScout Logo"
        style={{ height: '32px', width: 'auto' }}
      />
      <div
        style={{
          fontSize: '24px',
          fontWeight: 700,
          background: `radial-gradient(circle at center, rgb(63, 105, 247) 0%, rgb(75, 132, 234) 70%, rgb(102, 172, 249) 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
        }}
      >
        FlipScout
      </div>
    </Link>
  );
};

export default Logo;
